<oth-card [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate" [headerTemplate]="headerTemplate"
          class="doc-card">
  <!-- Header -->
  <ng-template #headerTemplate>
    <ng-container *ngTemplateOutlet="docHeader || defaultdocHeader">
      <!-- Header of the card -->
    </ng-container>
    <ng-template #defaultdocHeader>
      <div *ngIf="defaultHeaderContent" class="header">
        {{ defaultHeaderContent }}
      </div>
    </ng-template>
  </ng-template>

  <!-- Body -->
  <ng-template #bodyTemplate>
    <div class="body">
      <!-- Body of the card -->
      <markdown [src]="src" class="oth-docs-markdown"></markdown>
      <p>{{ date }}</p>
    </div>
  </ng-template>

  <!-- Footer -->
  <ng-template #footerTemplate>
    <div class="footer">
      <img [src]="BRAND.logo.main" alt="logo" class="brand-logo">
      <small>{{ BRAND.name }} <span class="copyright">© 2023</span></small>
    </div>
  </ng-template>
</oth-card>
